<template>
  <div>
    <div
      class="stemDescription"
      v-if="T.type == 1 || T.type == 2 || T.type == 3 || T.type == 4"
    >
      <div class="title-html" style="flex: 1">
        <div v-html="T.stemDescriptionHtml"></div>
      </div>
    </div>
    <div
      class="stemDescription"
      v-if="T.type == 5 && Array.isArray(T.optionContent)"
    >
      <div
        class="b-type-btn"
        v-if="!topicOptionExpand"
        @click="topicOptionExpand = true"
      >
        点击查看【b型题】公共选项
      </div>
      <div v-if="topicOptionExpand" @click="topicOptionExpand = false">
        <p>【b型题】公共选项</p>
        <ul class="common-option-ul">
          <li
            v-for="option in T.optionContent"
            :key="option.optionTypeDesc"
            class="common-option"
          >
            <span>{{ option.optionTypeDesc }}</span>
            <div class="option-name" v-html="option.optionTextHtml"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicStemDescription",
  props: {
    T: Object
  },
  data: function() {
    return {
      topicOptionExpand: false
    };
  }
};
</script>

<style lang="scss">
.stemDescription {
  display: block;
  color: #333;
  flex: 1;
  padding: 6px;
  max-height: 180px;
  overflow: auto;
  font-size: 17px;
  p {
    margin: 6px 0;
    word-break: break-all;
  }
}
.common-option-ul {
  margin: 0;
  .common-option {
    overflow-x: auto;
    display: flex;
    align-items: center;
    span {
      width: 20px;
    }
    .option-name {
      flex: 1;
      p {
        word-break: break-all;
      }
    }
  }
}
.b-type-btn {
  color: #222222;
  padding: 16px 0;
  font-weight: bold;
  font-size: 15px;
}
</style>
